const $ = require('jquery');
import LookupTable from "../../components/lookupTable/index";
import run from '../../utilities/run';
import render from "../../utilities/render";
import { isPresent } from "../../utilities/general";
import { statusPillRender, buildExport, prepareDataToSendController, isEdit, doAjax, pushFilterSessionCacheState, retriveCriteriaObjectByOperation, isNew, isDeleteView, isOnlyLookupDataUpdate } from "../../utilities/filtersutil";
import { actionOptions } from "./filter/organizationActionOptions.js";
import { orgLookupFieldDropdown } from "./filter/organizationLookupFieldDropdown.js";
import { handleCustomDropdownEvents } from "../../utilities/customBootstrapDropdowns";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { SUCCESS_MODAL_TIMEOUT } from "../../constants";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT } from "../../constants";
const modalHtml = require("../../sharedHtml/modal.html");
const _ = require("underscore");
const detailLinkHTML = require('../../utilities/filtersutil/html/detailLinkHTML.html');
const targetSelector = "#organization-lookup";

let actionCellDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let actionHeaderDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html');

run(targetSelector, (mainEl) => {
  const dataTableComponentData = mainEl.data("organization-lookup-data");
  const submitModalFlow = new SubmitModalFlow();
  const deactivateOrgURL = mainEl.data("deactivate-org-url");
  submitModalFlow.init();
  const savedViews = mainEl.data("saved-views");
  const portletNamespace = mainEl.data("portlet-namespace");
  const filterURL = mainEl.data("filter-url");
  const saveViewURL = mainEl.data("save-view-url");
  const deleteViewURL = mainEl.data("delete-view-url");
  const editOrganizationUrl = mainEl.data("edit-organization-url");
  const viewOrganizationUrl = mainEl.data("organization-detail-url");
  const viewBrokerOrganizationUrl = mainEl.data("broker-organization-detail-url");
  const viewCarrierOrganizationUrl = mainEl.data("carrier-organization-detail-url");
  
  
  const generateExportUrl = mainEl.data("export-url");
  const pageRefreshUrl = mainEl.data("page-refresh-url");
  const bulkActivateDeactivateBtnUrl = mainEl.data("bulk-activate-organization-url");
  let selectedRows = "";
  let targetObject = "";
  let exportModal = new buildExport();
  const facilityTypes = mainEl.data("facility-types");
  const inboundClassification = mainEl.data("inbound-classification");
  const editOrgUrl = mainEl.data("edit-url");
  const shouldCheckCache = $(targetSelector).data("should-check-cache");
  const criteriaObjectFromServer = $(targetSelector).data("filter-criteria-from-server");
  if (shouldCheckCache) { 
    targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer, "like");
  }
  const editPermission =  mainEl.data("organization-edit-permission"); 

  const activateOrg = mainEl.data("activate-org-msg");
  const deactivateOrg = mainEl.data("deactivate-org-msg");
  const activateOrgModelTitle = mainEl.data("activate-org-model-title");
  const deactivateOrgModelTitle = mainEl.data("deactivate-org-model-title");


  let activateDiv = render('<div class="q-pad-all-xl">{%-activateMsg %}</div>', {
      activateMsg: mainEl.data("activate-org-text")
    }
  );

  let deactivateDiv = render('<div class="q-pad-all-xl">{%-deactivateMsg %}</div>', {
      deactivateMsg: mainEl.data("deactivate-org-text")
    }
  );

  let organizationLookup = new LookupTable({

    target: $("#organization-lookup-wrapper"),

    minWidthClass: "q-min-width-sm-til-md",

    mobileColumns: [
      {
        data: "orgActive",
        title: "Status",
        render: renderStatusPill
      },
      {
        data: "orgName",
        title: "Organization Name",
        render: createDetailLink
      },
      {
        data: "orgType",
        title: "Organization Type",
        class: "dtc-min-width-sm"
      },
      {
        data: "orgActive",
        title: "Status",
        render: renderStatusPill,
        class: 'dtc-min-width-sm'
      },
      {
        data: "cmrAddress[].cadContactName",
        title: "Contact",
        render:renderCmrAddress,
        class: "dtc-min-width-sm"
      },
      {
        data: "cmrAddress[].cadContactEmail",
        title: "Email",
        render:renderCmrAddress,
        class: "dtc-min-width-sm"
      },
      {
        data: "cmrAddress[].cadContactPhone",
        title: "Phone",
        render:renderCmrAddress,
        class: "dtc-min-width-sm"
      },
      {
        data: "cmrAddress[].cadAddress1",
        title: "Address",
        render:renderCmrAddress,
        class: "dtc-min-width-sm"
      },
      {
        data: "orgCreatedBy",
        title: "Created By",
        class: "dtc-min-width-sm"
      },
      {
        data: "orgCreatedTime",
        title: "Created On",
        render: formateDate,
        class: "dtc-min-width-sm"
      }
    ],

    // REQUIRED: search input info
    tableSearchInput: {
      value: (targetObject != "" ? targetObject.value[0] : "")
    },
    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
    tableSearchDropdown: {
      selected: (targetObject == "" ? "" : targetObject.key),
      columns: orgLookupFieldDropdown
    },

    // OPTIONAL: Set Saved View Array
    savedViews: savedViews,
    bulkSelect: true,

    dataTable: {
      // use same settings you would if you were just calling a dataTable normally
      data: dataTableComponentData.content,
      // Not required, just to show you can
      columnDefs: [],
      order: [
        [10, 'desc']
      ],

      columns: [
        {
          data: "orgActive",
          render: renderActionWrap,
          orderable: false,
          class: "dtc-action-column"
        },
        {
          data: "orgName",
          title: "Organization Name",
          render: createDetailLink,
          class: "dtc-min-width-sm"
        },
        {
          data: "orgType",
          title: "Organization Type",
          class: "dtc-min-width-sm"
        },
        {
          data: "orgActive",
          title: "Status",
          render: renderStatusPill,
          class: 'dtc-min-width-sm'
        },
        {
          data: "cmrAddress[].cadContactName",
          title: "Contact",
          render:renderCmrAddress,
          class: "dtc-min-width-sm"
        },
        {
          data: "cmrAddress[].cadContactEmail",
          title: "Email",
          render:renderCmrAddress,
          class: "dtc-min-width-sm"
        },
        {
          data: "cmrAddress[].cadContactPhone",
          title: "Phone",
          render:renderCmrAddress,
          class: "dtc-min-width-sm"
        },
        {
          data: "cmrAddress[].cadAddress1",
          title: "Address",
          render:renderCmrAddress,
          class: "dtc-min-width-sm"
        },
        {
          data: "orgCreatedBy",
          title: "Created By",
          class: "dtc-min-width-sm"
        },
        {
          data: "orgCreatedTime",
          title: "Created On",
          render: formateDate,
          class: "dtc-min-width-sm"
        }

      ]
    },

    paginationData: dataTableComponentData.page,

    filterModal: {
      title: "Filter Organizations",
      tableType: "organization"
    },

    onBulkSelectChange: function () {
      selectedRows = organizationLookup.getBulkSelectedData();
      $("th.dtc-action-column").html(renderActionHeaderWrap());
      if (selectedRows.length >= 2) {
        $(".action-header-btn .base-btn").removeClass('disabled');
      } else {
        $(".action-header-btn .base-btn").addClass('disabled');
      }
    },

    onFetch: function () {
      let currentData = organizationLookup.generateData();
      organizationLookup.showLoadingOverlay();
      //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
      if (isOnlyLookupDataUpdate(currentData)) {
        setTimeout(() => {
          doAjax({ url: filterURL, success: filterSuccessFun, error: errorFun, data: prepareDataToSendController(currentData) });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isNew(currentData)) {
        setTimeout(() => {
          doAjax({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: prepareDataToSendController(currentData) });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isEdit(currentData)) {
        setTimeout(() => {
          doAjax({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: prepareDataToSendController(currentData) });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isDeleteView(currentData)) {
        setTimeout(() => {
          doAjax({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: prepareDataToSendController(currentData) });
        }, SUCCESS_MODAL_TIMEOUT);
      }
    }
  });

  function filterSuccessFun(data) {
    let organization = data.content;
    let page = data.page;
    organizationLookup.setNewData(organization);
    organizationLookup.setPaginationData(page);
    pushFilterSessionCacheState();
    organizationLookup.hideLoadingOverlay();
    setExportData(organizationLookup.generateData());
  }

  function savedViewSuccess(data) {
    let organization = data.lookupOrgJSON.content;
    let page = data.lookupOrgJSON.page;
    organizationLookup.setNewData(organization);
    organizationLookup.setPaginationData(page);
    organizationLookup.setNewSavedViewData(data.savedView, "newSavedView");
    pushFilterSessionCacheState();
    organizationLookup.hideLoadingOverlay();
    setExportData(organizationLookup.generateData());
  }

  function savedEditViewSuccess(data) {
    let organization = data.lookupOrgJSON.content;
    let page = data.lookupOrgJSON.page;
    organizationLookup.setNewData(organization);
    organizationLookup.setPaginationData(page);
    organizationLookup.setNewSavedViewData(data.savedView, data.savedView.target);
    pushFilterSessionCacheState();
    organizationLookup.hideLoadingOverlay();
    setExportData(organizationLookup.generateData());
  }

  function delteViewScussFun(data) {
    let organization = data.lookupOrgJSON.content;
    let page = data.lookupOrgJSON.page;
    organizationLookup.removeSavedView(data.target);
    organizationLookup.setNewData(organization);
    organizationLookup.setPaginationData(page);
    organizationLookup.hideLoadingOverlay();
    setExportData(organizationLookup.generateData());
  }

  function errorFun(data) {
    organizationLookup.hideLoadingOverlay();
  }

  organizationLookup.init();

  function renderActionWrap(data, type, row, meta) {
    let newRender;
    let statusTarget = actionOptions["actions"];
    newRender = render(
      actionCellDropdownTemplate, {
        list: renderActionCellList(statusTarget, data, row),
        index: meta.row
      }
    );
    return newRender;
  }

  function renderActionHeaderWrap() {
    let statusTarget = actionOptions['all'];
    let newRender;
    let data = "";
    let row = "";
    newRender = render(
      actionHeaderDropdownTemplate, {
        list: renderActionCellList(statusTarget, data, row)
      }
    );
    return newRender;
  }

  function renderActionCellList(list, data, row) {
    let renderedList = _(list).map((item) => {
      return render(
        actionCellDropdownItemTemplate, neededActions(data, row, item)
      );
    });
    return renderedList.join('');
  }

  function neededActions(data, row, item) {
    let action = {};
    if (editPermission && item.title === 'Activate/Deactivate') {
      if (data === true) {
        action = {
          icon: 'toggle-off',
          title: 'Deactivate',
          cls: "deactivate-organization",
          disabled: false
        };
      } else {
        action = {
          icon: 'toggle-on',
          title: 'Activate',
          cls: "activate-organization",
          disabled: false
        };
      }
     } else if (editPermission && item.title === 'Edit') {
        action = {
          icon: item.icon,
          title: item.title,
          cls: item.cls,
          disabled: false
        };
    } else if (editPermission && item.title === 'Activate Selected Organizations') {
      action = {
        icon: item.icon,
        title: item.title,
        cls: item.cls,
        disabled: checkDisableForGivenAction(data, row, item.title)
      };
    } else if (editPermission && item.title === 'Deactivate Selected Organizations') {
      action = {
        icon: item.icon,
        title: item.title,
        cls: item.cls,
        disabled: checkDisableForGivenAction(data, row, item.title)
      };
    } else {
      action = {
        icon: item.icon,
        title: item.title,
        cls: item.cls,
        disabled: item.disabled
      };
    }
    return action;
  }

  function checkDisableForGivenAction(data, row, actionName) {
    let isTrue = false;
    _(selectedRows).map((item) => {
      if (callBusinessLogicToDisableAction(item.data.orgActive, item.data, actionName)) {
        if (!isTrue) {
          isTrue = true;
        }
      }
    });
    return isTrue;
  }

  function callBusinessLogicToDisableAction(data, row, actionName) {
    if (isPresent(data)) {
      if (actionName === "Activate Selected Organizations") {
        if (data === true) {
          return true;
        } else {
          return false;
        }
      }
      else if (actionName === "Deactivate Selected Organizations") {
        if (data === false) {
          return true;
        } else {
          return false;
        }
      }
    }
  }

  function renderCmrAddress(data){
    if(data ==null || data == "")
    {
      return null;
    }
    return data[0];
  }

  function formateDate(createdDate, type, data){
    if(createdDate != null && createdDate != "") {
      let date = new Date(createdDate); //createdDate is long time format
      let month = date.getMonth() + 1;
      return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear();
    } else {
      return "";
    }
  }

  function renderStatusPill(data, type, row) {
    if (data === true) {
      return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue q-pill-table'>Active</div>";
    } else {
      return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue-border q-pill-table'>Inactive</div>";
    }
  }

  function createDetailLink(data, type, row) {
    let detailPageHTML = render(
      detailLinkHTML, {
        renderURL: getOrgDetailsURL(row),
        portletNamespace: portletNamespace,
        id: row.orgId,
        idName: "orgId",
        displayVal: data
      }
    );
    return detailPageHTML;
  }
  // Export component integration.
  function initExport() {
    let exportObj = {
      title: mainEl.data("export-popup-title"),
      exportAttemptTextPart1Lang: mainEl.data("export-attempt-text-part1"),
      exportAttemptTextPart2Lang: mainEl.data("export-attempt-text-part2"),
      exportMaxLimitLang: mainEl.data("export-max-row-limit")
    };
    exportModal.init(exportObj);
    exportModal.bindExportEvent();
  }

  function setExportData(currentData) {
    exportModal.buildExportBasicURL(generateExportUrl, currentData);
    exportModal.setExportCount(currentData.totalElements);
  }
  initExport();
  setExportData(organizationLookup.generateData());

  handleCustomDropdownEvents();

  $("th.dtc-action-column").html(renderActionHeaderWrap());


  function shallAllowClick(currentObj) {
    return !($(currentObj).hasClass("disabled"));
  }

  function getOrgDetailsURL(org){
    if(org.orgType =='Transportation Broker'){
      return viewBrokerOrganizationUrl;
    }else if(org.orgType =='Carrier'){
      return viewCarrierOrganizationUrl;
    }else{
      return viewOrganizationUrl;
    }
   
  }

  $('body').on('click', '.bulk-activate-organization', function () {
    if (shallAllowClick(this)) {
      $("#bulkActivateOrg").modal("show");
    }
  });

  $('#modalBulkActivateOrg').click(function () {
    submitModalFlow.showLoadingModal();
    bulkActivateDeativateOrg(true);
  });

  $('body').on('click', '.bulk-deactivate-organization', function () {
    if (shallAllowClick(this)) {
      $("#bulkDeActivateOrg").modal("show");
    }
  });

  $('#modalBulkDeActivateOrg').click(function () {
    submitModalFlow.showLoadingModal();
    bulkActivateDeativateOrg(false);
  });


  function bulkActivateDeativateOrg(val) {
    $.ajax({
      url: bulkActivateDeactivateBtnUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        [`${portletNamespace}orgId`]: getAllSelectedOrgIds(),
        activeDeativeFlag: val
      },
      success: function (data) {
        if (data.response === "success") {
          _(selectedRows).map((item) => {
            let currentRow = $(".data-table-component").dataTable().api().row(item.rowIndex);
            let d = currentRow.data();
            d.orgActive = val;
            currentRow.data(d).draw();
          });
          setTimeout(function () {
            submitModalFlow.hideAllModals();
          }, SUCCESS_MODAL_TIMEOUT);

        }
      },
      error: function () {
        submitModalFlow.hideAllModals();
      }
    });
  }


  function getAllSelectedOrgIds() {
    let orgIds = new Array();
    _(selectedRows).map((item) => {
      orgIds.push(item.data.orgId);
    });
    return JSON.stringify(orgIds);
  }

  $('body').on('click', '.edit-organization', function (e) {
    e.preventDefault();
    if(shallAllowClick(this)) { 
      let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
      let parent = $(".dropdown-parent-" + pIndex).parents('tr');
      let row = $(".data-table-component").dataTable().api().row(parent);
      let organization = row.data();
      let orgId = `${organization.orgId}`;
      editOrganizationCall(orgId);
    } 
  });

  function editOrganizationCall(orgId) {
    location.href = editOrgUrl + "&orgId=" + orgId;
  }

  $('body').on('click', '.activate-organization', function (e) {
    e.preventDefault();
    if(shallAllowClick(this)) { 
      let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
      let parent = $(".dropdown-parent-" + pIndex).parents('tr');
      let row = $(".data-table-component").dataTable().api().row(parent);
      let organization = row.data();
      let orgId = `${organization.orgId}`;
      activateOrganizationCall(orgId);
    }

  });

  function activateOrganizationCall(orgId) {
    let activateOrgModal = new SubmitModalFlow({
      confirmModalTitle: activateOrgModelTitle,
      confirmModalBody: activateDiv,
      confirmModalBtnText: activateOrg,
      modalDialogClass: "q-modal-dialog-500",
      onConfirmClick: function () {
        activateOrgModal.showLoadingModal();
        activateOrg({ url: deactivateOrgURL, success: activateSuccess, error: activateFailure });
        function activateOrg({ url, success, error }) {
          $.ajax({
            data: {
              orgId: orgId
            },
            url: url,
            dataType: "JSON",
            type: 'POST',
            success: success,
            error: error
          });
        }
        function activateSuccess() {
          activateOrgModal.showSuccessModal();
          setTimeout(function () {
            location.href = pageRefreshUrl;
          }, 3000);
        }
        function activateFailure() {
          setTimeout(function () {
            activateOrgModal.hideAllModals();
          }, 6000);
        }
      }
    });
    activateOrgModal.init();
    activateOrgModal.showConfirmModal();
  }

  $('body').on('click', '.deactivate-organization', function (e) {
    e.preventDefault();
    if(shallAllowClick(this)) {
      let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
      let parent = $(".dropdown-parent-" + pIndex).parents('tr');
      let row = $(".data-table-component").dataTable().api().row(parent);
      let organization = row.data();
      let orgId = `${organization.orgId}`;
      deactivateOrganizationCall(orgId);
    }
  
  });

  function deactivateOrganizationCall(orgId) {
    let deactivateOrgModal = new SubmitModalFlow({
      confirmModalTitle: deactivateOrgModelTitle,
      confirmModalBody: deactivateDiv,
      confirmModalBtnText: deactivateOrg,
      modalDialogClass: "q-modal-dialog-500",
      onConfirmClick: function () {
        deactivateOrgModal.showLoadingModal();
        deactivateOrg({ url: deactivateOrgURL, success: deactivateSuccess, error: deactivateFailure });
        function deactivateOrg({ url, success, error }) {
          $.ajax({
            url: url,
            data: {
              orgId: orgId
            },
            dataType: "JSON",
            type: 'POST',
            success: success,
            error: error
          });
        }
        function deactivateSuccess() {
          deactivateOrgModal.showSuccessModal();
          setTimeout(function () {
            location.href = pageRefreshUrl;
          }, 3000);
        }
        function deactivateFailure() {
          setTimeout(function () {
            deactivateOrgModal.hideAllModals();
          }, 6000);
        }
      }
    });
    deactivateOrgModal.init();
    deactivateOrgModal.showConfirmModal();
  }

});


// WEBPACK FOOTER //
// ./src/pages/addressBook/OrganizationLookup.js